import { Link, RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

const TermsAndConditions = () => (
  <RouteWrapper>
    <section>
      <p>
        PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE TAKING ADVANTAGE
        OF, VISITING OR USING ANY COMPONENT OF THE CREHANA´S PLATFORM. IT IS
        ALSO NECESSARY TO READ THE PRIVACY POLICIES, WHERE WE DETAIL OUR
        INFORMATION HANDLING PRACTICES
        <Link href="https://www.crehana.com/legal/politicas-de-privacidad/" />.
        WE CARE ABOUT KEEPING OUR USERS SAFE AND WE ARE CONSTANTLY WORKING TO
        COLLECT INFORMATION CONFIDENTIALLY. THE ACCESS AND/OR USE OF THE WEBSITE
        BY ANY USER (AS SUCH TERM IS DEFINED LATER) IMPLIES THE FULL ACCEPTANCE
        OF ALL THE PROVISIONS INCLUDED IN THIS DOCUMENT AND THE RESPECTIVE
        SERVICES AGREEMENT SIGNED BY THE CUSTOMERS. THE PRESENT TERMS AND
        CONDITIONS GOVERN THE RELATIONSHIP BETWEEN CREHANA AND CUSTOMERS IN
        RELATION TO THE PROVISION OF SERVICES AND LICENSE TO ACCESS CONTENT IN
        ACCORDANCE WITH THE SERVICES AGREEMENT SIGNED BETWEEN EACH CUSTOMER AND
        CREHANA. THE CUSTOMER STATES THAT IT IS A DULY INCORPORATED COMPANY AND
        THAT THE CUSTOMER AND ITS LEGAL REPRESENTATIVE HAS THE NECESSARY LEGAL
        CAPACITY TO BE BOUND ACCORDING TO THESE TERMS AND CONDITIONS, AS WELL AS
        ACCORDING TO THE SERVICES AGREEMENT. LIKEWISE, A CHOICE OF APPLICABLE
        LAW AND JURISDICTION THAT APPLIES TO ANY CLAIM FILED BEFORE CREHANA IS
        INCLUDED. CUSTOMER COMMITS TO COMPLY AND MAKE ITS USERS COMPLY WITH
        THESE TERMS AND CONDITIONS, AS WELL AS WITH THOSE GENERAL TERMS AND
        CONDITIONS OF USE OF THE CREHANA´S PLATFORM THAT ARE PUBLISHED AT THE
        FOLLOWING ADDRESS: [
        <Link href="https://www.crehana.com/legal/terminos-y-condiciones/" />
        ].
      </p>
    </section>
    <section>
      <Subtitle>1. Definitions</Subtitle>
      <p>
        The following terms will have the meaning indicated below when used with
        capital letters, either in the singular or plural:
      </p>
      <p>
        <strong>Activation</strong>, means the start-up and validation of
        everything necessary to conduct the proper provision of the Services,
        which includes, but is not limited to, implementations, integrations,
        documentation review and other actions to be carried out by Crehana.
      </p>
      <p>
        <strong>Services Agreement</strong>, means the document mutually
        executed by Crehana and the Customer, including all those orders that
        are processed by electronic means, which provides, at least, the
        following items: (i) the Consideration to be covered by the Customer for
        the Provision of services; (ii) the Term of the Services; (iii) the
        number of Users authorized to access the Platform and its Contents; (iv)
        billing and payment information; and (v) any other particularity
        applicable to the provision of the Services to the Customer.
      </p>
      <p>
        <strong>Affiliate</strong>, means any entity that directly controls, is
        controlled by, or is under common control with another entity.
      </p>
      <p>
        <strong>Customer</strong>, means the party that has executed a Services
        Agreement with Crehana or has accessed the Services in any other way.
      </p>
      <p>
        <strong>Activation and onboarding consultancy</strong>, means the value
        that the Customer will pay Crehana annually, at the beginning of the
        Services and later on each anniversary, so that Crehana may conduct the
        activation, adaptations, implementations, and improvements in the
        accompaniment and lines Customer&apos;s career. Payment for this service
        will be added to the cost of issuing the first invoice and will
        subsequently be added to the invoice for each anniversary.
      </p>
      <p>
        <strong>Content</strong>, means the online education products offered
        through the Crehana Platform.
      </p>
      <p>
        <strong>Price</strong>, means the amount to be paid by the Customer to
        Crehana for access to the Services and use of the Content on the
        Platform and/or the Content License as established in the Services
        Agreement under the heading: Annual Cost.
      </p>
      <p>
        <strong>Crehana</strong>, means commercial brand of the group of
        companies located in:
        <ul>
          <li>
            Crehana Education Mexico, S. de R.L. de C.V. with address at Av.
            Paseo de la Reforma 296, 25th floor, office 118, neighborhood Benito
            Juárez, Cuauhtémoc Delegation, Mexico City, Mexico, C.P. 06600.
          </li>
          <li>
            Crehana Education Peru S.A.C. with address at Coronel Andrés Reyes
            Street No. 338, Urbanization Jardin Int. 02-1, San Isidro district,
            Lima, Peru.
          </li>
          <li>
            Crehana Education Colombia S.A.S. with address in 96 street # 12 -
            31 Floor 3, in Bogota D.C.
          </li>
          <li>
            Crehana Education Chile Capacitaciones SpA, with address at
            Providencia No. 1650, Office 611, Providencia district, City of
            Santiago, Metropolitan Region.
          </li>
          <li>
            Crehana Education Inc., with address at 2035 Sunset Lake Road, Suite
            B-2, city of Newark, county of New Castle, 19702, Delaware, USA.
          </li>
        </ul>
      </p>
      <p>
        <strong>Personal data</strong>, means the personal data of individuals
        or entities, identified or identifiable, that is in possession of
        Crehana of which the Customer, as the owner of the information, has
        consented to its treatment in accordance with the privacy notice (
        <Link href="https://www.crehana.com/legal/politicas-de-privacidad/" />)
        or by executing the Services Agreement.
      </p>
      <p>
        <strong>License</strong>, means the non-exclusive right of use of the
        contents owned by Crehana that is granted to Customers for a certain
        period in accordance with the terms selected in the Services Agreement
        and any modification or update that is made to such Agreement.
      </p>
      <p>
        <strong>Parties</strong>, means the Customer and Crehana.
      </p>
      <p>
        <strong>Platform</strong>, means the website{' '}
        <Link href="https://www.crehana.com/" />, the virtual platform and/or
        other digital media such as applications for smartphones with IOS or
        Android technology, tablets, SmartTV´s, among others, owned by Crehana,
        within which Users register to obtain the Service.
      </p>
      <p>
        <strong>Services</strong>, means any of the Services that are purchased
        by Customer under the Services Agreement, and that are described in
        Section 2 of these Terms and Conditions.
      </p>
      <p>
        <strong>Terms and Conditions</strong>, means these general terms and
        conditions for contracting Crehana´s services, as modified from time to
        time, as well as those referred to in Section 4 herein.
      </p>
      <p>
        <strong>Users</strong>, means those Internet users identified by the
        Customer to have access and right to use the Platform and access to the
        corresponding Services in accordance with this Services Agreement.
      </p>
    </section>
    <section>
      <Subtitle>2. Scope of Services</Subtitle>
      <p>
        Crehana undertakes to provide the Customer with educational services on
        several fields of knowledge through its Platform by granting a License,
        or the development of tailored courses or programs as agreed by Crehana
        and the Customer in the Services Agreement; which may be modified or
        updated according to the Customer&apos;s needs from time to time.
      </p>
    </section>
    <section>
      <Subtitle>3. Grant of License</Subtitle>
      <p>
        Subject to the compliance of the Terms and Conditions, Crehana grants in
        favor of the Customer a temporary, revocable, non-exclusive,
        non-transferable license, not subject to sub-licenses, with an
        obligation to pay the Price, to access the Contents of Crehana, as well
        as the operation of said application including updates and support
        regarding the Crehana´s platform.
      </p>
    </section>
    <section>
      <Subtitle>4. Price</Subtitle>
      <p>
        In exchange for the provision of the Services and the granting of the
        License as appropriate in accordance with the Services Agreement, the
        Customer shall pay the total value established in such Agreement in the
        established credit period.
      </p>
    </section>
    <section>
      <Subtitle>5. Industrial Property and Copyright</Subtitle>
      <p>
        The content of our platform is protected by the copyright regulations in
        force in the United States of America, as well as by the local laws of
        each of our subsidiaries:
      </p>
      <ul>
        <li>Chile: Law 17336, Intellectual Property Law.</li>
        <li>
          Colombia: Intellectual Property Law: Law 23 of 1982, partially
          modified by Law 1915 of 2018, and the international treaties in which
          Colombia participates
        </li>
        <li>
          Mexico: the Federal Law for the Protection of Industrial Property and
          the Federal Law on Copyright and the corresponding international
          treaties.
        </li>
        <li>
          Peru: the Law on Copyright (Legislative Decree 822), its amendments
          and the corresponding international treaties.
        </li>
      </ul>
      <p>
        Crehana, its subsidiaries, affiliates and/or licensors are the owners of
        the industrial and intellectual rights related to and/or derived from
        this platform.
      </p>
      <p>
        Crehana, its logos and all the material that appears on said platform,
        programs, documents or others, are trademarks, domain names, trade names
        and artistic works owned by Crehana, its subsidiaries, affiliates and/or
        licensors and are protected by the international treaties and applicable
        laws on industrial and intellectual property.
      </p>
      <p>
        The copyright on the content, organization, collection, compilation,
        information, logos, photographs, images, programs, applications, and in
        general any information contained or published on the platform, programs
        or others, are duly protected in favor of Crehana , its subsidiaries,
        affiliates and/or licensors in accordance with the applicable
        legislation on intellectual and industrial property.
      </p>
      <p>
        The Customer and the Users are expressly prohibited from modifying,
        altering or deleting, either in whole or in part, the notices,
        trademarks, trade names, signs, advertisements, logos or in general any
        indication that refers to the ownership of the information contained on
        the designated platform. Likewise, the Customer and the Users undertake
        not to display, distribute, grant licenses, execute, publish, reproduce,
        duplicate, copy, create derivative works, modify, sell, resell, exploit,
        transfer or upload for commercial purposes, any part of the Service, the
        use of the Service or the access to the Content.
      </p>
      <p>
        Any total or partial exploitation of the industrial and intellectual
        property rights related to and/or derived from the Service will require
        the prior written consent of Crehana.
      </p>
      <p>
        Any intellectual property rights that have been authorized by Crehana
        for editorial purposes must contain the following legend:
      </p>
      <p>
        “Reserved Rights, © Crehana Education Colombia S.A.S., with address at
        96 street # 12 - 31 Floor 3, in Bogota D.C.
      </p>
      <p>
        Rights Reserved, © Crehana Education Chile Capacitaciones S.P.A., with
        address at Av. Providencia 1650, office 611, Santiago de Chile, Chile.
      </p>
      <p>
        Rights Reserved, © Crehana Education Inc., with address at 2035 Sunset
        Lake Road, Suite B-2, city of Newark, county of New Castle, 19702,
        Delaware, USA.
      </p>
      <p>
        Rights Reserved, © Crehana Education México, S. de R.L. de C.V., with
        address at Av. Paseo de la Reforma 296, 25th floor, office 118,
        neighborhood Benito Juárez, Cuauhtémoc Delegation, Mexico City, Mexico,
        C.P. 06600.
      </p>
      <p>
        Rights Reserved, © Crehana Education Peru S.A.C. with address at Coronel
        Andrés Reyes Street No. 338, Urbanization Jardin Int. 02-1, San Isidro
        district, Lima, Peru.
      </p>
      <p>
        The Customer and the Users irrevocably agree not to display, distribute,
        grant licenses, execute, publish, reproduce, duplicate, copy, create
        derivative works, modify, sell, resell, exploit, share its use for
        different users, transfer or upload for commercial purposes, any part of
        the Service, the use of the Service and the Platform or the access to it
        and the Content.
      </p>
    </section>
    <section>
      <Subtitle>6. Responsibility</Subtitle>
      <p>
        Whenever the Software, mechanisms, programs, procedures, distinctive
        signs, equipment, systems, techniques and/or other copyrights owned by
        Crehana do not in any way infringe any kind of copyright or industrial
        property, Crehana disclaims any responsibility towards the Customer, for
        which it does not assume any responsibility to indemnify or defend and
        remove the Customer in peace and safe from any demand, litigation,
        complaint, action or claim, whatever its nature, whatever filed against
        you, in which it is invoked to have a better right over any rights
        related to the License or the Services.
      </p>
      <p>
        For its part, the Customer undertakes to indemnify and keep harmless and
        release Crehana, its Affiliates, their respective shareholders,
        directors, managers, officers, employees, representatives, factors,
        advisors, subcontractors, and agents, in their person and property, from
        and against third party claims, damages, liabilities and expenses,
        directly related to or arising from a third party claim in relation to
        the License and the use thereof, in which the infringement of patents,
        rights of copyright, trademarks or industrial and/or commercial secrets,
        and due to gross negligence, fraud or willful conduct by the Customer.
      </p>
      <p>
        The Customer undertakes to notify Crehana in writing, within [5 (five)]
        business days after receiving a claim, and Crehana reserves the
        exclusive right to control and direct the investigation, defense or
        settlement of said claim, at the expense of the Customer.
      </p>
    </section>
    <section>
      <Subtitle>7. Advertising and brand use</Subtitle>
      <p>
        Crehana or any of its Affiliates may use the Customer&apos;s trade name
        and/or official logo to communicate on Crehana&apos;s channels, unless
        otherwise stated in the Services Agreement.
      </p>
      <p>
        These communications will be aimed at highlighting the joint work of
        Crehana and the Customer with the development of talent through
        Crehana&apos;s communication channels, including without limitation
        social networks, blog, website.
      </p>
    </section>
    <section>
      <Subtitle>8. Non-exclusivity</Subtitle>
      <p>
        The License and the provision of the Crehana Services to the Customer do
        not grant any exclusivity rights over the Content or the Services, so
        that Crehana may authorize the use of the Content and provide the
        Services to any third party, provided that it does not represent a
        breach to your Confidentiality obligations under these Terms and
        Conditions.
      </p>
    </section>
    <section>
      <Subtitle>9. Confidentiality</Subtitle>
      <p>
        All non-public, confidential or proprietary information of the Parties,
        including, but not limited to, specifications, samples, patterns,
        designs, plans, drawings, documents, data, business operations, customer
        lists, prices and discounts, whether disclosed orally or disclosed in
        writing, electronically or by any other type or means, in relation to
        the relationship established by the parties (the &quot;Confidential
        Information&quot;) is confidential, and may be used solely for the use
        of the Parties in the execution of the these Terms and Conditions, and
        may not be disclosed or copied unless previously authorized in writing
        by the other Party.
      </p>
      <p>
        At the request of one Party, the other Party shall immediately return
        all documents and other materials or information received. This clause
        shall not apply to information that is: (i) in the public domain; (ii)
        known prior to disclosure; or (iii) lawfully obtained on a
        non-confidential basis from a third party. Likewise, the Parties
        acknowledge that the information referred to in this clause constitutes
        a transcendental asset for Crehana.
      </p>
      <p>
        By virtue of the foregoing, the Parties undertake and guarantee that all
        Confidential Information provided to them will be kept and treated
        confidentially and used for the sole purpose of providing the Services
        and complying with their obligations under the Terms and Conditions and
        the Services Agreement and that it will not be disclosed in any way, in
        whole or in part, during the time the obligations remain in force and
        after their termination, unless there is prior written consent of the
        other Party.
      </p>
      <p>
        Additionally, Crehana undertakes to disclose Confidential Information
        only to persons who need to know the Confidential Information in order
        to provide the Services and who have been previously informed of the
        terms of this clause.
      </p>
      <p>
        The obligations set forth in this document will remain fully in force
        and with due legal force, without prejudice to the return or destruction
        of the Confidential Information after the expiration date.
      </p>
    </section>
    <section>
      <Subtitle>10. Non-employment relationship</Subtitle>
      <p>
        The provision of the Services in accordance with these Terms and
        Conditions, as well as the Services Agreement and documents related to
        them, regulate the provision of services and it cannot be interpreted
        that it creates an association, company, economic unit or any similar
        entity between the Parties, since it consists of an autonomous
        commercial relationship. Derived from the foregoing, each of the Parties
        is independent and will be responsible for its own obligations to third
        parties, as well as for its labor, administrative and fiscal
        obligations, therefore, the Parties agree that they will release the
        other peacefully and safely. Party to any claim or lawsuit brought
        against the other party as a result of the violation of the obligations
        described herein, at your own cost.
      </p>
      <p>
        Crehana expressly acknowledges that there is no element of subordination
        between its employees and the Customer. In terms of the foregoing, the
        responsibility derived from the labor relations between Crehana and its
        employees corresponds to it in a unique and exclusive manner, for which
        reason Crehana will be considered the employer of each and every one of
        its employees, as it is the only party that benefits from the services
        provided by such employees.
      </p>
      <p>
        In relation to the foregoing, Crehana expressly undertakes to indemnify
        and hold harmless the Customer (including its parent company,
        subsidiaries, related companies, its Customers, its shareholders,
        directors, employees and/or consultants) from any claim, demand, risk,
        damage, loss, loss of profits, costs or expenses (including legal
        expenses) that are generated or that are related in any way to any
        labor, social security, commercial, civil conflict or of any nature that
        arises generated between Crehana and any of its employees that argues
        the existence of an employment relationship between said workers and the
        Customer and who claim from the latter the payment of any labor benefit,
        compensation, lost wages, reinstatement, etc., as well as as a result of
        any claim, inspection and/or audit carried out by any labor authority in
        relation to the services performed by Crehana employees.
      </p>
      <p>
        Likewise, Crehana will be responsible for the performance of its
        personnel in the provision of the Services, for which the Customer does
        not assume any responsibility of a fiscal nature.
      </p>
    </section>
    <section>
      <Subtitle>11. Personal Data</Subtitle>
      <p>
        Crehana undertakes to treat the Personal Data to which it has access due
        to the relationship with the Customer as Confidential Information, in
        terms of these Terms and Conditions, and to use the same solely and
        exclusively for the purposes described in Crehana&apos;s privacy notice.
        [(https://www.crehana.com/legal/avisos-de-privacidad/ )], to provide the
        Services to the Customer and Users.
      </p>
      <p>
        In the event that the Customer is the one who directly collects
        sensitive personal and financial data from the Users, it is obliged to
        provide the Users with its privacy notice that contains the same
        purposes as the Crehana privacy notice and states that it knows and
        understands the obligations and Responsibilities of the Managers and
        Managers in accordance with the Personal Data Protection Law applicable
        in each country as follows: Mexico: Federal Law on Protection of
        Personal Data Held by Private Parties, its Regulations and other
        relative and applicable ones; Colombia: Law 1581 of 2012, Regulatory
        Decree 1377 of 2013 and other concordant regulations; Peru: Law 29733 of
        2011 and its amendments; Chile Law 19,628 on the Protection of Private
        Life and its complementary regulations; obligations and responsibilities
        that in this act unfailingly assumes.
      </p>
    </section>
    <section>
      <Subtitle>12. Modifications to the Terms and Conditions</Subtitle>
      <p>
        These Terms and Conditions may be modified by Crehana at any time,
        however, in any case, its Customers will always be notified of said
        modifications or updates in advance and within this notice authorization
        will be sent to continue with the contractual relationship under these
        new terms and conditions. The modifications will be effective
        immediately after their publication for new Customers and for those old
        ones after they are expressly accepted when accessing the platform at
        the following address:{' '}
        <Link href="https://www.crehana.com/legal/terms-and-conditions-b2b/" />
      </p>
    </section>
    <section>
      <Subtitle>13. Assignment</Subtitle>
      <p>
        Crehana may at any time assign the rights and obligations under the
        Services Agreement and these Terms and Conditions to: an Affiliate; (ii)
        Crehana&apos;s successor by virtue of a merger, corporate
        reorganization, consolidation or sale; or (iii) to the entity that
        acquires all or a substantial part of Crehana&apos;s assets or
        businesses for which the goods or services were acquired or are being
        used.
      </p>
    </section>
    <section>
      <Subtitle>14. Applicable law and choice of jurisdiction</Subtitle>
      <p>
        The Parties expressly agree that these Terms and Conditions, as well as
        the Services Agreement and any document derived from them, will be
        governed and interpreted in accordance with the laws of each country
        where Crehana has a legal presence and in accordance with the accepted
        contractual address. by the parties.
      </p>
      <p>
        For the interpretation, fulfillment and execution of the obligations
        derived from these Terms and Conditions, the Services Agreement and any
        document derived from them, the Parties expressly and irrevocably submit
        to the jurisdiction of the competent courts of Mexico City, expressly
        and irrevocably renouncing any other jurisdiction they may have or may
        acquire for any reason.
      </p>
    </section>
    <section>
      <Subtitle>15. Validity</Subtitle>
      <p>
        The relationship between the parties will be in force during the term
        indicated in the Services Agreement.
      </p>
      <p>
        The term of the activation and onboarding consulting service will be
        that established in the Services Agreement, for which the Customer
        undertakes to provide Crehana with all the facilities and provide all
        the information and/or documentation required by Crehana in a timely
        manner. prior to service activation and onboarding.
      </p>
      <p>
        If for any reason the Customer delays in providing the facilities and/or
        in providing all the information and/or documentation required, the
        Activation and Onboarding Consulting Service could be delayed, in which
        case Crehana will not be responsible for said delay. and the foregoing
        will not exempt the Customer from fulfilling its payment obligations
        within the terms established in the Services Agreement. In the case
        mentioned in which the Customer is the one who generates the delays, the
        duration of the service will begin to count from the date initially
        agreed.
      </p>
      <p>
        At the end of the term indicated in the Services Agreement, the
        provision of the Services will be automatically renewed monthly.
      </p>
      <p>
        In such event, the Consideration will be paid and invoiced in accordance
        with the list price (without discounts).
      </p>
      <p>
        If the Customer does not want the Service to be automatically renewed,
        he or she must contact Crehana by email addressed to him or the Account
        Executive, with a copy to legal@crehana.com and billing@crehana.com
        sixty (60) calendar days prior to expiration term.
      </p>
      <p>
        If the Service has already been automatically renewed, the Customer must
        notify its willingness to terminate the agreement within the first
        fifteen (15) calendar days and the termination will apply to the
        following calendar month.
      </p>
    </section>
    <section>
      <Subtitle>16. Integrity of these Terms and Conditions</Subtitle>
      <p>
        These terms and conditions constitute the entire agreement between the
        Parties in relation to the services and granting of the License, as
        applicable, and supersede all prior or contemporaneous communications,
        proposals and representations, oral or written, with respect to its
        object.
      </p>
    </section>
    <section>
      <Subtitle>17. Contact details</Subtitle>
      <p>
        Please contact us via email to the Account Executive, with a copy to{' '}
        <Link href="legal@crehana.com" /> if you have any questions about these
        Terms and Conditions, the scope of the Services or report any incident.
      </p>
    </section>
  </RouteWrapper>
);

export default TermsAndConditions;
